<template>
	<div ref="el" data-component="card-team">
		<div class="image-wrapper">
			<ImageAsset v-if="resolvedPhoto" :asset="resolvedPhoto" class="desktop-image" />
			<!-- <nuxt-img src="/imgs/temp/team.jpg" alt="table wireframe graphic" /> -->
			<svg class="curve" viewBox="0 0 392 48" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M392 47.3383V48H0L3.05176e-05 0H220.85C241.222 0 260.649 8.59438 274.352 23.6692C288.055 38.7439 307.481 47.3383 327.853 47.3383H392Z" fill="#0551F5" />
			</svg>
		</div>

		<div class="content">
			<h4 class="-headline-3 name">{{ name }}</h4>

			<div class="role-linkedin">
				<p class="-body-medium role">{{ role }}</p>

				<a v-if="linkedin" :href="linkedin" target="_blank" rel="noopener noreferrer">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect width="40" height="40" rx="20" fill="#0D0D18" />
						<path d="M15.4132 16.8604H12.2656V27.9996H15.4132V16.8604Z" fill="white" />
						<path
							d="M13.8361 15.5646C14.8501 15.5646 15.6721 14.7666 15.6721 13.7823C15.6721 12.798 14.8501 12 13.8361 12C12.822 12 12 12.798 12 13.7823C12 14.7666 12.822 15.5646 13.8361 15.5646Z"
							fill="white"
						/>
						<path
							d="M27.9996 27.9996H24.8521V22.3287C24.8521 18.916 20.6554 19.1793 20.6554 22.3287V27.9996H17.5078V16.8604H20.6554V18.6528C22.1242 16.03 27.9996 15.8376 27.9996 21.1641V28.0097V27.9996Z"
							fill="white"
						/>
					</svg>
				</a>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ImageAsset } from '~/components/core'

const props = defineProps({
	name: { type: [Boolean, String], default: 'ic-ai-inside' },
	role: { type: String, default: 'No Label' },
	linkedin: { type: [String, Boolean], default: false },
	photo: { type: [Object, Array], default: undefined },
})

const resolvedPhoto = computed(() => (Array.isArray(props.photo) ? props.photo[0] : props.photo))

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.loaded.then(() => setup())
	context.$page.loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='card-team'] {
	position: relative;

	width: column-width(4);
	border-radius: rs(12, 12);
	overflow: hidden;

	box-shadow: 0 29px 39px 0 rgba(0, 68, 179, 0.2);

	@include max-width($sm) {
		width: column-width(4, true);
	}

	@include max-width($xs) {
		width: column-width(13);
	}
	.image-wrapper {
		position: relative;

		img {
			object-fit: cover;
			width: 100%;
			height: 100%;
		}

		.curve {
			position: absolute;
			bottom: -1px;
			left: 0;
			width: 100%;

			display: flex;

			path {
				fill: var(--color-river-blue-500);
			}
		}
	}

	.content {
		position: relative;

		display: flex;
		flex-direction: column;
		justify-content: space-between;

		height: rs(202, 130);
		padding: rs(16, 16);

		background-color: var(--color-river-blue-500);

		.name {
			width: 70%;
			margin-top: rs(-50, -35);

			color: var(--color-geral-white);

			white-space: pre-line;
		}

		.role-linkedin {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;

			.role {
				color: var(--color-river-blue-100);
			}
			svg {
				width: rs(40, 20);
				height: rs(40, 20);
				overflow: visible;

				rect {
					transition: 200ms ease;
				}

				@media (hover: hover) {
					&:hover {
						rect {
							opacity: 0.8;
							transform: scale(1.07);
							transform-origin: center;
						}
					}
				}
			}
		}
	}
}
</style>
